// @ts-nocheck
import React, { CSSProperties, Suspense } from 'react'
import dayjs from 'dayjs'
import { Icon } from '../generic'
import Field from 'components/fields'
import { colors } from '@lmc/common/constants'
import { Text } from '@lmc/ui-kit'

type Props = {
  fields?: any
  formId?: string
  setFormField?: any
  style?: CSSProperties
}

export default class CarePlanNextReviewField extends React.Component<
  Props,
  any
> {
  state = {
    selectedRadio: null,
  }

  componentDidMount() {
    const { fields } = this.props
    if (fields && fields.noFurtherSupportRequired) {
      this.setState({
        selectedRadio: 'no-identified-need',
      })
    }
  }

  handleRadioClick = (id) => {
    if (this.state.selectedRadio === id) return null
    this.setState({ selectedRadio: id })
    const noFurtherSupportRequired = id === 'no-identified-need'

    const times = {
      'no-identified-need': null,
      week: dayjs().add(1, 'weeks').format('DD-MM-YYYY'),
      month: dayjs().add(1, 'months').format('DD-MM-YYYY'),
      'three-months': dayjs().add(3, 'months').format('DD-MM-YYYY'),
    }

    this.props.setFormField({
      key: FIELD_ID,
      value: times[id],
    })
    this.props.setFormField({
      key: 'noFurtherSupportRequired',
      value: noFurtherSupportRequired,
    })
  }

  renderRadios = () => {
    const { selectedRadio } = this.state
    return RADIOS.map(({ id, label }) => (
      <div
        id={`add-${id}`}
        key={`add-${id}`}
        data-cy={`add-${id}`}
        onClick={() => this.handleRadioClick(id)}
        style={styles.radioContainer}
      >
        <Icon
          name={id === selectedRadio ? 'radio-on' : 'radio-off'}
          fill={id === selectedRadio ? colors.pink : null}
          size={24}
        />
        <span data-cy={`add-${id}`} style={styles.radioLabel}>{label}</span>
      </div>
    ))
  }

  renderDateField = () => {
    const { fields, formId } = this.props
    if (fields.noFurtherSupportRequired) {
      return <div style={styles.noEditDate}>DD-MM-YYYY</div>
    }

    return (
      <Suspense fallback={<div>Loading...</div>}>
      <Field
        keys={FIELD_ID}
        label="Next review date"
        layout="no-label"
        formId={formId}
		format={false}
        options={{
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
		  formatOnBlur: true
        }}
        required
        placeholder="DD-MM-YYYY"
        style={styles.inputContainer}
        type="formattedText"
        validationTypes={['validDate', 'futureDate']}
        values={fields}
      />
      </Suspense>
    )
  }

  render() {
    const { fields, formId, style, date, noFurtherSupportRequired } = this.props
    const title = 'Next review'

    let displayDate
    if (!formId) {
      displayDate = date ? dayjs(date).format('DD-MM-YYYY') : 'No date set'
    }
    return (
      <div
        className="lmc-card"
        style={{
          ...style,
          ...styles.container,
        }}
      >
        {formId ? (
          <Text style={styles.commentTitle} as="h5">
            Any additional comments on this review?
          </Text>
        ) : null}
        <Suspense fallback={<div>Loading...</div>}>
        <Field
          keys={COMMENT_FIELD_ID}
          label={COMMENT_FIELD_ID}
          layout="no-label"
          formId={formId}
          style={styles.commentInput}
          type="textarea"
          values={fields}
        />
        </Suspense>
        <Text style={styles.reviewTitle}>{title}</Text>
        <div style={styles.dateContainer}>
          <div style={styles.iconContainer}>
            <Icon fill="black" name="calendar" size={24} />
          </div>
          {formId ? (
            this.renderDateField()
          ) : (
            <span style={styles.dateText}>
              {noFurtherSupportRequired
                ? 'No further support required'
                : displayDate}
            </span>
          )}
        </div>
        {formId && this.renderRadios()}
      </div>
    )
  }
}

const FIELD_ID = 'nextReviewDate'
const COMMENT_FIELD_ID = 'newComment'

const RADIOS = [
  {
    id: 'week',
    value: dayjs().add(1, 'weeks').format('DD-MM-YYYY'),
    label: '1 week',
  },
  {
    id: 'month',
    value: dayjs().add(1, 'months').format('DD-MM-YYYY'),
    label: '1 month',
  },
  {
    id: 'three-months',
    value: dayjs().add(3, 'months').format('DD-MM-YYYY'),
    label: '3 months',
  },
  {
    id: 'no-identified-need',
    label: 'No further support required',
  },
]

const styles = {
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    padding: '13px 25px',
  },
  commentInput: {
    marginBottom: 20,
  },
  commentTitle: {
    paddingBottom: 10,
  },
  dateText: {
    alignSelf: 'center',
    display: 'block',
    paddingLeft: 15,
  },
  iconContainer: {
    alignSelf: 'center',
    marginLeft: 5,
    width: 24,
    height: 24,
  },
  inputContainer: {
    paddingLeft: 15,
    marginRight: 20,
  },
  dateContainer: {
    alignSelf: 'center',
    display: 'flex',
  },
  radioContainer: {
    alignSelf: 'center',
    cursor: 'pointer',
    display: 'flex',
    height: 24,
    marginRight: 20,
  },
  radioLabel: {
    alignSelf: 'center',
    display: 'block',
    marginLeft: 5,
  },
  noEditDate: {
    padding: 9.5,
    marginLeft: 17,
    marginRight: 85,
    opacity: 0.6,
  },
  reviewTitle: {
    alignSelf: 'center',
    display: 'block',
    margin: '3px 20px 3px 0px',
  },
}
